export const SERVICE_SLUGS = [
  'internal-software',
  'process-automation',
  'chatbots-virtual-agents',
  'rags-knowledge-systems',
  'custom-dashboards',
  'forecasting-classification',
  'websites-virtual-businesses',
  'technical-seo-audit',
  'meta-ads-audit',
  'global-digital-audit',
  'automated-prospecting',
  'custom-ai-tools',
] as const;

export type ServiceSlug = (typeof SERVICE_SLUGS)[number];

export const isServiceSlug = (slug: string): slug is ServiceSlug =>
  (SERVICE_SLUGS as readonly string[]).includes(slug);
